import React, { useRef, useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "./styles/Main.css";

import Image1 from "./imgs/0001.jpg";
import Image2 from "./imgs/0002.jpg";
import Image3 from "./imgs/0003.jpg";
import Image4 from "./imgs/0004.jpg";
import RoomImage1 from "./imgs/room1.jpg";
import RoomImage2 from "./imgs/room2.jpg";
import RoomImage3 from "./imgs/room3.jpg";
import GoogleMapImage from "./imgs/googlemap_en.png";

function Main() {
  const navigate = useNavigate();

  const topRef = useRef(null);
  const aboutSectionRef = useRef(null);
  const roomSectionRef = useRef(null);
  const activitySectionRef = useRef(null);

  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);

  const handleImageClick = () => {
    navigate("/gallery");
  };

  const handleJpClick = () => {
    navigate("/jp");
  }

  const handleEnClick = () => {
    navigate("/");
  };

  const images = [
    { src: Image1, alt: "Room view" },
    { src: Image2, alt: "Outside view" },
    { src: Image3, alt: "Dining area" },
    { src: Image4, alt: "Bed room" },
  ];

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const handleMenuItemClick = (ref) => {
    setIsMenuOpen(false);
    if (ref.current) {
      const offset = 80;
      const elementPosition = ref.current.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;

      window.scrollTo({
        top: offsetPosition,
        behavior: "smooth",
      });
    }
  };

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
    }, 3000);
    return () => clearInterval(interval);
  }, [images.length]);

  return (
    <div>
      <div ref={topRef}></div>
      <header className="header">
        <div id="top" className="logo" onClick={() => handleMenuItemClick(topRef)}>
          NAKAYAMA VILLA
        </div>
        <button className="menu-toggle" onClick={toggleMenu}>
          {isMenuOpen ? "✖" : "☰"}
        </button>
        <nav className={`nav-menu ${isMenuOpen ? "open" : ""}`}>
          <ul className="menu-list">
            <li>
              <a href="#about" onClick={() => handleMenuItemClick(aboutSectionRef)}>ABOUT US</a>
            </li>
            <li>
              <a href="#rooms" onClick={() => handleMenuItemClick(roomSectionRef)}>ROOMS</a>
            </li>
            <li>
              <a href="#access" onClick={() => handleMenuItemClick(roomSectionRef)}>ACCESS</a>
            </li>
            <li>
              <a href="" onClick={handleImageClick}>GALLERY</a>
            </li>
            <li>
              <a href="https://www.booking.com/Share-3IdcLz" target="_blank" rel="noopener noreferrer">Booking.com</a>
            </li>
            <li>
              <a href="https://www.airbnb.jp/rooms/1335947108229180506?guests=1&adults=1&s=67&unique_share_id=9a5fd18c-b849-48f4-8382-b99a6d57e886" target="_blank" rel="noopener noreferrer">Airbnb</a>
            </li>
          </ul>
        </nav>
        <div className="language-button">
          <a href="/jp" onClick={handleJpClick}>JP</a>
        </div>
      </header>

      <main>
        <div id="" className="carousel-container">
          <section className="description">
            <p>Japanese Cultural House in Hiroshima <br />～Enjoy Your Relaxing Time～</p>
          </section>

          <div className="carousel">
            {images.map((image, index) => (
              <div key={index} className={`carousel-item ${index === currentIndex ? "active" : ""}`}>
                <img src={image.src} alt={image.alt} />
              </div>
            ))}
          </div>
        </div>

        <section id="about" className="about" ref={aboutSectionRef}>
          <h3>About Our Accommodation</h3>
          <p>Welcome to Nakayama Villa.</p>
          <p>Offering stunning views of the garden.</p>
          <p>A luxurious 165-square-meter space located near the Hiroshima Expressway.</p>
          <p>Enjoy the beautiful garden and private parking.</p>
          <p>Equipped with an EV charging station.</p>
          <p>A terrace and balcony for relaxing.</p>
          <p>About 3 km away from Ikejiri Children's Park.</p>
          <p>About 2.6 km to Aeon Mall Hiroshima Fuchu.</p>
          <p>We warmly welcome you to NAKAYAMA VILLA.</p>
          <div className="booking-buttons">
            <a
              href="https://www.booking.com/Share-3IdcLz"
              target="_blank"
              rel="noopener noreferrer"
              className="about-button"
            >
              Booking.com
            </a>
            <span>&nbsp;</span>
            <a
              href="https://www.airbnb.jp/rooms/1335947108229180506?guests=1&adults=1&s=67&unique_share_id=d3a96f38-2897-4eea-a952-2938d1d361e9"
              target="_blank"
              rel="noopener noreferrer"
              className="about-button"
            >
              Airbnb
            </a>
          </div>
        </section>

        <section id="rooms" className="room-section" ref={roomSectionRef}>
          <p className="room-title-en">Rooms</p>
          <h2 className="room-title">Relaxing Spaces</h2>
          <div className="room-images">
            <div className="room-image-large">
              <img src={RoomImage1} alt="Room Large View" />
            </div>
            <div className="room-image-small">
              <img src={RoomImage2} alt="Room Bedroom" />
              <img src={RoomImage3} alt="Room Tea Set" />
            </div>
          </div>
          <div className="room-description">
            <h3>About Our Rooms</h3>
            <p>
              Accommodation can host up to 8 guests.
              <br />
              Three bedrooms, and Japanese-style living room.
              <br />
              Perfect for family trips or group stays.
              <br />
              Free parking, kitchen, and a washing machine.
              <br />
              Complimentary EV charging stations.
              <br />
              A tranquil experience to calm your mind.
              <br />
              Unlimited high-speed internet is available.
              <br />
              Enjoy streaming services.
            </p>
            <div className="booking-buttons">
              <a
                href="https://www.booking.com/Share-3IdcLz"
                target="_blank"
                rel="noopener noreferrer"
                className="about-button"
              >
                Booking.com
              </a>
              <span>&nbsp;</span>
              <a
                href="https://www.airbnb.jp/rooms/1335947108229180506?guests=1&adults=1&s=67&unique_share_id=d3a96f38-2897-4eea-a952-2938d1d361e9"
                target="_blank"
                rel="noopener noreferrer"
                className="about-button"
              >
                Airbnb
              </a>
            </div>
          </div>
        </section>

        <section id="access" className="access" ref={activitySectionRef}>
          <p className="access-title-en">Access</p>
          <h2 className="access-title">What's near by?</h2>
          <div className="access-content">
            <div className="access-map">
              <img src={GoogleMapImage} alt="Access Map" />
            </div>
            <div className="access-text">
              <p>
                This luxurious house is located just off the Umaki Interchange on the Hiroshima Expressway and has a site of over 200 square meters. Luxurious space of 165 square meters, right next to the Hiroshima Expressway, convenient for car travel. Free parking and charging stations are available. It is 3.3 km from Hiroshima Station and 3.5 km from Sorajoyama Park. Hiroshima Airport is 43 km away. These facilities are within 10 minutes walking distance.
                <br />
                <br />
                <a>① Nakayama Villa</a>
                <br />
                <a href="https://map.yahoo.co.jp/v3/place/cZucn2l6pGU">② Inari Shrine </a>
                <br />
                <a href="https://ameblo.jp/hirodai-kouko/entry-12869328129.html">③ Nakayama Shell Mound</a>
                <a href="https://drive.google.com/file/d/1YUpBW5ybwl8SEKqItvb3wKCqUW2S9axX/view?usp=sharing">（Detail）</a>
                <br />
                <a href="https://www.hiroshimapeacemedia.jp/?p=123829">④ Mankyu Temple</a>
                <br />
                <a href="https://www.joysound.com/web/shop/detail/123106">⑤ Karaoki</a>
                <br />
                <a>⑥ Convenience Store（LAWSON）</a>
                <br />
                <a href="https://tabelog.com/hiroshima/A3401/A340104/34021384/">⑦ Izakaya</a>
                <br />
                <a href="https://himawarinews.com/store/nakayama_pharmacy/">⑧ Pharmacy</a>
                <br />
                <a>⑨ Post Office</a>
                <br />
                <a href="https://tabelog.com/hiroshima/A3401/A340104/34025036/">⑩ Okonomiyaki（Kishin）</a>
                <br />
                <a href="https://tokubai.co.jp/%E3%82%B9%E3%83%91%E3%83%BC%E3%82%AF/10670">⑪ Super Market（SPARK）</a>
                <br />
                <a href="https://www.foleo.jp/hiroshimahigashi/index.html">⑫ Shopping Mole（Foreo Hiroshima East）</a>
                <br />
                <a href="https://drive.google.com/file/d/1RzfvGbtGpLnud5CVeuVsnG3t8avWsixc/view?usp=sharing">⑬ Shinkansen Depot</a>
                <br />
              </p>
              <a href="" onClick={handleImageClick} className="access-button">
                MORE INFO
              </a>
            </div>
          </div>
        </section>

      </main>

      <footer className="footer">
        <div className="footer-container">
          <div className="footer-center">
            <div className="footer-address">
              <h3>NAKAYAMA VILLA</h3>
              <p>〒732-0023</p>
              <p>3-8-3, Nakayamahigashi, Higashi-ku</p>
              <p>Hiroshima City, Hiroshima Prefecture</p>
              <p>© NAKAYAMA VILLA</p>
            </div>
          </div>

          <div className="footer-links">
            <div className="footer-column">
              <a href="#">TOP</a>
              <a href="#about">ABOUT US</a>
              <a href="#rooms">ROOMS</a>
              <a href="#access">ACCESS</a>
              <a href="" onClick={handleImageClick}>GALLERY</a>
              <a href="https://www.booking.com/Share-3IdcLz" target="_blank" rel="noopener noreferrer" onClick={() => handleMenuItemClick(roomSectionRef)}>BOOKING</a>
            </div>
            <div className="footer-column">
              <a href="jp" onClick={handleJpClick}>Japanese</a>
              <a href="" onClick={handleEnClick}>English</a>
            </div>
          </div>
        </div>
      </footer>

    </div>
  );
}

export default Main;
